import { useCookies } from 'react-cookie';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import FadeIn from "react-fade-in/lib/FadeIn"
import { getCurrentRole, getStyle, getStepRedux, setStepRedux, getBizID } from "../../libs/todoSlice";
import LoadingComponent from "../../lib/LoadingComponent";
import { getLoadingRedux, setLoadingRedux } from "../../libs/manageMemberSlice";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CreateIcon from '@mui/icons-material/Create';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Swal from "sweetalert2";
import fontColor from "../../lib/fontColor";
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Form, Card, Table, Empty, Radio, Space, Input, Typography, Dropdown, Menu, Popconfirm } from 'antd';
import { Row, Col } from 'react-bootstrap';
import { UserOutlined, MailOutlined, SwitcherOutlined, CloudDownloadOutlined, DatabaseOutlined, LockOutlined, UnorderedListOutlined } from '@ant-design/icons';


const EmailSMTP = () => {
    const [cookie, setCookie, removeCookie] = useCookies(['account'])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const style = useSelector(getStyle)
    const [step, setStep] = useState('home');
    const biz_id = useSelector(getBizID)

    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('')
    const [updateID, setUpdateID] = useState('')
    const [statusID, setStatusID] = useState('')
    const [listData, setListData] = useState('')
    const [countListData, setCountListData] = useState(0)
    const [defaultListData, setDefaultListData] = useState([])
    const [data, setData] = useState([]);

    useEffect(() => {
        
    }, [cookie, step]);

    const loading = useSelector(getLoadingRedux)
    const setLoading = (action) => {
        dispatch(setLoadingRedux({
            loading: action
        }))
    }

    const currentRole = useSelector(getCurrentRole)
    const [valueCheck, setValueCheck] = useState("use-inet");
    const [usernameCheck, setUsernameCheck] = useState("user-no");
    const [isEnabled, setIsEnabled] = useState(true);

    const [isModalEnabledOpen, setIsModalEnabledOpen] = useState(false);
    const [isSwitchOn, setIsSwitchOn] = useState(false);
    const [pendingSwitchStatusEnabled, setPendingSwitchStatusEnabled] = useState(null);

    const EnabledSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: `${style.secondary_color} !important`,
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
        },
    }));


    const handleRadioChange = e => {
        setUsernameCheck(e.target.value)
        setIsEnabled(e.target.value === "user-no");
    };

    const handleRadioValueChange = (e) => {
        setValueCheck(e.target.value);
        setSmtpHost('')
        setSmtpPost('')
        setUsername('')
        setPassword('')
        setSenderName('')
        setSenderEmail('')
        setSenderBCC('')
        setErrors({
            senderName: '',
            senderEmail: ''
        });
    };

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };

    const handleEdit = (record) => {
        getSMTP(record)
        setStep('edit')
    };

    const handleDelete = (record) => {
        Swal.fire({
            title: "ต้องการลบข้อมูลนี้ใช่หรือไม่?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteSMTP(record)
            }
        });
    };

    const deleteSMTP = async (record) => {
        setLoading(true)
        await axios({
            method: 'DELETE',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/smtp?biz_id=${biz_id}&id=${record.id}`,
        }).then(() => {
            Swal.fire({
                title: "ลบข้อมูลสำเร็จแล้ว",
                icon: "success"
            }).then(() => {
                setListData(listData.filter(e => e._id !== record.id).map((e, index) => {
                    return {
                        ...e,
                        index: index + 1,
                    }
                }))
                setDefaultListData(defaultListData.filter(e => e._id !== record.id).map((e, index) => {
                    return {
                        ...e,
                        index: index + 1,
                    }
                }))
                setCountListData(countListData - 1)
                window.location.reload();
            })
        }, ({ response }) => {
            Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "ไม่สามารถลบข้อมูลได้",
                icon: "error"
            });
        })
        setLoading(false)
    }

    const paginationStyle = {
        display: 'flex',
        justifyContent: 'right',
    };

    const [errors, setErrors] = useState({
        senderName: '',
        senderEmail: ''
    });
    const validateFields = () => {
        let hasError = false;
        const newErrors = {};

        if (!senderName) {
            newErrors.senderName = 'กรุณากรอกชื่อผู้ส่ง';
            hasError = true;
        }
        if (!senderEmail) {
            newErrors.senderEmail = 'กรุณากรอกอีเมลแอดเดรสผู้ส่ง';
            hasError = true;
        }

        setErrors(newErrors);
        return !hasError;
    };

    useEffect(() => {
        getPagination()
    }, [page, pageSize, searchText])

    const monthNamesTH = [
        'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
        'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
    ];
    const formatDate = (isoString) => {
        if (!isoString) return '-';
        const date = new Date(isoString);
        const day = (`0${date.getDate()}`).slice(-2);
        const month = monthNamesTH[date.getMonth()];
        const year = date.getFullYear();
        const hours = (`0${date.getHours()}`).slice(-2);
        const minutes = (`0${date.getMinutes()}`).slice(-2);
        const seconds = (`0${date.getSeconds()}`).slice(-2);

        return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
    };

    const getPagination = async () => {
        try {
            const { data, status } = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/smtp/list?biz_id=${biz_id}`,
                params: {
                    page: page,
                    size: pageSize,
                    searching: searchText
                }
            })
            const list = data.data.data

            let list_data = list.map((list, index) => {
                return {
                    index: index + 1,
                    name_sender: list.nameSender ? list.nameSender : '-',
                    email_sender: list.emailSender ? list.emailSender : '-',
                    smtp_host: list.smtpHost ? list.smtpHost : '-',
                    smtp_post: list.smtpPost ? list.smtpPost : '-',
                    date: formatDate(list.updatedAt),
                    connection: list.isSMTP,
                    id: list._id,
                    username: list.username ? list.username : '-',
                    password: list.password ? list.password : '-',
                    email_bcc: list.emailBcc ? list.emailBcc : '-',
                    enabled: list.active,
                    operated: list.userDetails
                }
            })
            setListData(list_data)
            setCountListData(data.data.total)
            setDefaultListData(list_data)
            setStatusID(list_data.length > 0 ? list_data[0].id : '')
        } catch ({ response }) {

        }
    };

    const [displayPassword, setDisplayPassword] = useState('**********')
    const [showPassword, setShowPassword] = useState(false)
    const maskPassword = (password) => {
        return '*'.repeat(password.length); // Replaces the password characters with '*'
    };
    const handlePasswordChangeStar = (e) => {
        setPassword(e.target.value);
    };

    const getSMTP = async (record) => {
        setLoading(true)
        await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/smtp?biz_id=${biz_id}&id=${record.id}`,
        }).then(({ data, status }) => {
            let account = { ...data.data }

            setSmtpHost(account.smtpHost)
            setSmtpPost(account.smtpPost)
            setUsername(account.smtpUsername)
            setPassword(account.smtpPassword)
            setDisplayPassword('**********')
            setSenderName(account.nameSender)
            setSenderEmail(account.emailSender)
            setSenderBCC(account.emailBcc)
            setValueCheck(account.isSMTP == true ? "no-inet" : "use-inet")
            setUsernameCheck(account.isUsername == true ? "user-yes" : "user-no")
            setIsEnabled(account.isUsername == true ? false : true)
            setUpdateID(account._id)
        }, ({ response }) => {

        })
        setLoading(false)
    }
    const handlePasswordChange = (event) => {
        const newPassword = event.target.value;
        setPassword(newPassword)
    }
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    }

    const [smtpHost, setSmtpHost] = useState('')
    const [smtpPost, setSmtpPost] = useState('')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [senderName, setSenderName] = useState('')
    const [senderEmail, setSenderEmail] = useState('')
    const [senderBCC, setSenderBCC] = useState('')
    const createSMTP = async () => {
        if (validateFields()) {
            setLoading(true)
            await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/smtp`,
                data: {
                    biz_id: biz_id,
                    smtp_host: smtpHost,
                    smtp_port: smtpPost,
                    username: username,
                    password: password,
                    sender_name: senderName,
                    sender_email: senderEmail,
                    sender_bcc: senderBCC
                }
            }).then(({ data, status }) => {
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ',
                }).then(() => {
                    setStep('home')
                    getPagination()
                })
            }, ({ response }) => {
                const { status } = response
                Swal.fire({
                    icon: 'error',
                    title: 'บันทึกข้อมูลไม่สำเร็จ',
                })
            })
            setLoading(false)
        }
    }

    const updateSMTP = async () => {
        const result = await Swal.fire({
            title: "ต้องการเปลี่ยนแปลงข้อมูลนี้ใช่หรือไม่?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก"
        });
        if (result.isConfirmed && validateFields()) {
            setLoading(true);
            try {
                const response = await axios({
                    method: 'PATCH',
                    url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/smtp`,
                    data: {
                        biz_id: biz_id,
                        smtp_id: updateID,
                        smtp_host: smtpHost,
                        smtp_port: smtpPost,
                        username: username,
                        password: password,
                        sender_name: senderName,
                        sender_email: senderEmail,
                        sender_bcc: senderBCC
                    }
                });
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ',
                }).then(() => {
                    setStep('home');
                    getPagination();
                });
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'บันทึกข้อมูลไม่สำเร็จ',
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleSwitchChange = async (event, record) => {
        const newStatus = event.target.checked;
        const result = await Swal.fire({
            title: newStatus ? 'ต้องการเปิดใช้งานไหม?' : 'ต้องการปิดใช้งานไหม?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
        });

        if (result.isConfirmed) {
            try {
                await ChangeStatus(record.id, newStatus);
                setData((prevData) =>
                    prevData.map((item) =>
                        item.key === record.key ? { ...item, enabled: newStatus } : item
                    )
                );
            } catch (error) {
                console.error('Error changing status:', error);
                setData((prevData) =>
                    prevData.map((item) =>
                        item.key === record.key ? { ...item, enabled: !newStatus } : item
                    )
                );
            }
        }
    }

    const ChangeStatus = async (statusID, newStatus) => {
        await axios({
            method: 'POST',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/smtp/status`,
            data: {
                biz_id: biz_id,
                id: statusID,
                status: newStatus
            }
        }).then(({ data, status }) => {
            getPagination()
        }, ({ response }) => {

        })
    }

    const columns = [
        {
            title: 'ลำดับ',
            width: 60,
            dataIndex: 'index',
            key: 'index',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            sorter: (a, b) => a.index - b.index,
            render: (_, __, index) => {
                return (
                    <>{((page * pageSize) - pageSize) + index + 1}</>
                )
            }
        },
        {
            title: 'ชื่อผู้ส่ง',
            width: 150,
            dataIndex: 'name_sender',
            key: 'name_sender',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'อีเมลแอดเดรสผู้ส่ง',
            width: 150,
            dataIndex: 'email_sender',
            key: 'email_sender',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'Smtp Host',
            width: 150,
            dataIndex: 'smtp_host',
            key: 'smtp_host',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'Smtp Port',
            width: 100,
            dataIndex: 'smtp_post',
            key: 'smtp_post',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'ดำเนินการโดย',
            width: 150,
            dataIndex: 'operated',
            key: 'operated',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'วันที่ (เพิ่ม/แก้ไข)',
            width: 150,
            dataIndex: 'date',
            key: 'date',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'เปิดใช้งาน',
            width: 100,
            dataIndex: 'enabled',
            key: 'enabled',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => {
                return (
                    <EnabledSwitch
                        sx={{ m: 1 }}
                        checked={record.enabled}
                        onChange={(event) => handleSwitchChange(event, record)}
                    />
                );
            }
        },
        {
            title: 'รูปแบบการเชื่อมต่อ',
            width: 150,
            dataIndex: 'connection',
            key: 'connection',
            fixed: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (text, record, _) => {
                if (record.connection === false) {
                    return <Chip label="Mail Server INET" color="success" />;
                } else {
                    return <Chip label="Mail Server User" color="info" />;
                }
            }
        },
        {
            title: 'ตัวเลือก',
            width: 100,
            dataIndex: 'operation',
            key: 'operation',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => (
                <Dropdown
                    overlay={
                        <Menu>
                            <Menu.Item key="edit">
                                <Button startIcon={<CreateIcon />} variant="text" onClick={() => handleEdit(record)}>แก้ไขข้อมูล</Button>
                            </Menu.Item>
                            <Menu.Item key="delete">
                                <Button startIcon={<DeleteForeverOutlinedIcon />} variant="text" onClick={() => handleDelete(record)}>ลบข้อมูล</Button>
                            </Menu.Item>
                        </Menu>
                    }
                    trigger={['click']}
                >
                    <Button
                        variant="outlined"
                        startIcon={<UnorderedListOutlined />}
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            minWidth: 0,
                            padding: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'right',
                            border: 'none',
                            marginLeft: '20px'
                        }}
                        sx={!!style.primary_color && {
                            backgroundColor: `${style.secondary_color} !important`,
                            color: fontColor(style.secondary_color)
                        }}
                    />
                </Dropdown>
            )
        },
    ]


    return (
      <FadeIn>
        {
          {
            home: (
              <>
                <div>
                  <h3
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      margin: 10,
                      marginBottom: 30,
                    }}
                  >
                    ตั้งค่า SMTP อีเมล
                  </h3>
                </div>
                <Card style={{ borderRadius: "16px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      variant="contained"
                      style={{
                        width: 200,
                        height: 40,
                        marginLeft: 0,
                        marginRight: "auto",
                        marginTop: 12,
                      }}
                      sx={
                        !!style.primary_color && {
                          backgroundColor: `${style.secondary_color} !important`,
                          color: fontColor(style.secondary_color),
                        }
                      }
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setStep("setting");
                        setSmtpHost("");
                        setSmtpPost("");
                        setUsername("");
                        setPassword("");
                        setSenderName("");
                        setSenderEmail("");
                        setSenderBCC("");
                        setValueCheck("use-inet");
                        setUsernameCheck("user-no");
                        setIsEnabled(true);
                      }}
                    >
                      เพิ่มข้อมูล SMTP
                    </Button>

                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        margin: 20,
                        marginTop: 5,
                      }}
                    >
                      <input
                        placeholder="ค้นหา"
                        value={searchText}
                        style={{
                          position: "relative",
                          width: "380px",
                          height: "36px",
                          border: "1px solid #EEEEEE",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "6px",
                          marginTop: "40px",
                          marginRight: "15px",
                          marginBottom: "10px",
                          padding: "10px",
                          paddingRight: "2.5rem",
                        }}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                      />
                      <SearchIcon
                        style={{
                          position: "absolute",
                          top: "54%",
                          left: "21.5rem",
                          color: "#DADADA",
                        }}
                      />
                    </div>
                  </div>
                  <Table
                    locale={customLocale}
                    columns={columns}
                    dataSource={listData}
                    scroll={{
                      x: 1400,
                      y: 400,
                    }}
                    pagination={{
                      style: paginationStyle,
                      page: page,
                      pageSize: pageSize,
                      onChange: (page, pageSize) => {
                        setPage(page);
                        setPageSize(pageSize);
                      },
                      showSizeChanger: true,
                      // total: resulttotal
                    }}
                  />
                </Card>
              </>
            ),
            setting: (
              <>
                <div>
                  <h3
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      margin: 10,
                      marginBottom: 30,
                    }}
                  >
                    <a
                      onClick={() => {
                        setStep("home");
                        setSmtpHost("");
                        setSmtpPost("");
                        setUsername("");
                        setPassword("");
                        setSenderName("");
                        setSenderEmail("");
                        setSenderBCC("");
                        setErrors({
                          senderName: "",
                          senderEmail: "",
                        });
                      }}
                    >
                      <ArrowBackIosIcon
                        style={{ fontSize: "35px", marginBottom: "10px" }}
                      />{" "}
                      ตั้งค่า SMTP อีเมล
                    </a>
                  </h3>
                </div>
                <Card
                  title={
                    <span style={{ fontSize: "24px", fontWeight: "100" }}>
                      ข้อมูล SMTP
                    </span>
                  }
                  style={{ borderRadius: "16px" }}
                >
                  <div style={{ padding: "30px" }}>
                    <Row>
                      <Col xs={12}>
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                          รูปแบบการเชื่อมต่อ Mail Server Inet
                        </span>
                      </Col>
                      <Col xs={12} style={{ marginTop: "10px" }}>
                        <Radio.Group
                          value={valueCheck}
                          defaultValue={"use-inet"}
                          onChange={handleRadioValueChange}
                        >
                          <Space direction="vertical">
                            <Radio
                              value={"use-inet"}
                              style={{ fontSize: "17px" }}
                            >
                              ใช้ Mail Server ของทาง INET
                            </Radio>
                            <Radio
                              value={"no-inet"}
                              style={{ fontSize: "17px" }}
                            >
                              ใช้ Mail Server ของทางผู้ใช้งาน
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Col>
                      <Col xs={12}>
                        {valueCheck === "no-inet" && (
                          <Row>
                            {/* <Col xs={12} style={{ marginTop: '30px' }}>
                                        <div>
                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: 'red' }}>*** กรุณาแจ้ง SMTP Host ไปยังผู้ดูแลระบบ CMP เพื่อขอใช้งานก่อนทำการตั้งค่า</span>
                                        </div>
                                    </Col> */}
                            <Col xs={8} style={{ marginTop: "10px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Host
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="smtpHost"
                                  value={smtpHost}
                                  onChange={({ target }) => {
                                    setSmtpHost(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  prefix={<CloudDownloadOutlined />}
                                />
                              </div>
                            </Col>
                            <Col xs={4} style={{ marginTop: "10px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Post
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="smtpPost"
                                  value={smtpPost}
                                  onChange={({ target }) => {
                                    setSmtpPost(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  prefix={<DatabaseOutlined />}
                                />
                              </div>
                            </Col>

                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  ใช้งาน Username Password
                                </Typography.Title>
                                <Radio.Group
                                  value={usernameCheck}
                                  defaultValue={"user-no"}
                                  onChange={handleRadioChange}
                                  style={{ fontSize: "24px" }}
                                >
                                  <Radio
                                    value={"user-yes"}
                                    style={{ fontSize: "17px" }}
                                  >
                                    เปิดใช้งาน
                                  </Radio>
                                  <Radio
                                    value={"user-no"}
                                    style={{ fontSize: "17px" }}
                                  >
                                    ปิดใช้งาน
                                  </Radio>
                                </Radio.Group>
                              </div>
                            </Col>
                            <Col xs={8} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Username
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="username"
                                  value={username}
                                  onChange={({ target }) => {
                                    setUsername(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  disabled={isEnabled}
                                  prefix={<UserOutlined />}
                                />
                              </div>
                            </Col>
                            <Col xs={4} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Password
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="password"
                                  type={showPassword ? "text" : "password"} // Toggle between "text" and "password" types
                                  value={password}
                                  onChange={handlePasswordChange}
                                  style={{ height: "40px" }}
                                  disabled={isEnabled}
                                  prefix={<LockOutlined />}
                                  suffix={
                                    <span
                                      onClick={togglePasswordVisibility}
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                      }}
                                    >
                                      {showPassword ? "ซ่อน" : "แสดง"}{" "}
                                      {/* Toggle button text */}
                                    </span>
                                  }
                                />
                              </div>
                            </Col>

                            {/* <Col xs={12} style={{ marginTop: '30px' }}>
                                        <div>
                                            <Typography.Title level={5}>Transport Layer Security SSL (TLS)</Typography.Title>
                                            <Radio.Group defaultValue={"transport-yes"} style={{ fontSize: '24px' }}>
                                                <Radio value={"transport-yes"} style={{ fontSize: '17px' }}>เปิดใช้งาน</Radio>
                                                <Radio value={"transport-no"} style={{ fontSize: '17px' }}>ปิดใช้งาน</Radio>
                                            </Radio.Group>
                                        </div>
                                    </Col> */}
                          </Row>
                        )}
                      </Col>

                      <Col xs={12} style={{ marginTop: "30px" }}>
                        {(valueCheck === "use-inet" ||
                          valueCheck === "no-inet") && (
                          <Row>
                            <Col xs={12}>
                              <div>
                                <Typography.Title level={5}>
                                  ชื่อผู้ส่ง (Sender Display Name)
                                </Typography.Title>
                                <Input
                                  placeholder="Consent Management Platform"
                                  id="senderName"
                                  value={senderName}
                                  onChange={({ target }) => {
                                    setSenderName(target.value);
                                  }}
                                  style={{
                                    height: "40px",
                                    borderColor: errors.senderName
                                      ? "red"
                                      : undefined,
                                  }}
                                  prefix={<UserOutlined />}
                                />
                                {errors.senderName && (
                                  <div style={{ color: "red" }}>
                                    {errors.senderName}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  อีเมลแอดเดรสผู้ส่ง (Sender Email Address)
                                </Typography.Title>
                                <Input
                                  placeholder="no-reply-cmp@cmp.inet.co.th"
                                  id="senderEmail"
                                  value={senderEmail}
                                  onChange={({ target }) => {
                                    setSenderEmail(target.value);
                                  }}
                                  style={{
                                    height: "40px",
                                    borderColor: errors.senderEmail
                                      ? "red"
                                      : undefined,
                                  }}
                                  prefix={<MailOutlined />}
                                />
                                {errors.senderEmail && (
                                  <div style={{ color: "red" }}>
                                    {errors.senderEmail}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  ส่งสำเนาถึง (BBC Email Address)
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="senderBCC"
                                  value={senderBCC}
                                  onChange={({ target }) => {
                                    setSenderBCC(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  prefix={<SwitcherOutlined />}
                                />{" "}
                                <br />
                                <br />
                                {/* <span style={{ fontSize: '16px', fontWeight: 'bold', color: 'red' }}>หมายเหตุ: สามารถใช้เครื่องหมาย , (จุลภาค) หากต้องการส่งมากกว่า 1 อีเมล</span> */}
                              </div>
                            </Col>
                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div className="d-flex justify-content-center">
                                <Button
                                  style={{ width: "300px", fontSize: "16px" }}
                                  sx={
                                    !!style.primary_color && {
                                      backgroundColor: `${style.secondary_color} !important`,
                                      color: fontColor(style.secondary_color),
                                    }
                                  }
                                  onClick={() => {
                                    createSMTP();
                                  }}
                                >
                                  บันทึก
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Card>
              </>
            ),
            edit: (
              <>
                <div>
                  <h3
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      margin: 10,
                      marginBottom: 30,
                    }}
                  >
                    <a
                      onClick={() => {
                        setStep("home");
                      }}
                    >
                      <ArrowBackIosIcon
                        style={{ fontSize: "35px", marginBottom: "10px" }}
                      />{" "}
                      ตั้งค่า SMTP อีเมล
                    </a>
                  </h3>
                </div>
                <Card
                  title={
                    <span style={{ fontSize: "24px", fontWeight: "100" }}>
                      ข้อมูล SMTP
                    </span>
                  }
                  style={{ borderRadius: "16px" }}
                >
                  <div style={{ padding: "30px" }}>
                    <Row>
                      <Col xs={12}>
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                          รูปแบบการเชื่อมต่อ Mail Server Inet
                        </span>
                      </Col>
                      <Col xs={12} style={{ marginTop: "10px" }}>
                        <Radio.Group
                          value={valueCheck}
                          defaultValue={"use-inet"}
                          onChange={handleRadioValueChange}
                        >
                          <Space direction="vertical">
                            <Radio
                              value={"use-inet"}
                              style={{ fontSize: "17px" }}
                            >
                              ใช้ Mail Server ของทาง INET
                            </Radio>
                            <Radio
                              value={"no-inet"}
                              style={{ fontSize: "17px" }}
                            >
                              ใช้ Mail Server ของทางผู้ใช้งาน
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Col>
                      <Col xs={12}>
                        {valueCheck === "no-inet" && (
                          <Row>
                            {/* <Col xs={12} style={{ marginTop: '30px' }}>
                                        <div>
                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: 'red' }}>*** กรุณาแจ้ง SMTP Host ไปยังผู้ดูแลระบบ CMP เพื่อขอใช้งานก่อนทำการตั้งค่า</span>
                                        </div>
                                    </Col> */}
                            <Col xs={8} style={{ marginTop: "10px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Host
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="smtpHost"
                                  value={smtpHost}
                                  onChange={({ target }) => {
                                    setSmtpHost(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  prefix={<CloudDownloadOutlined />}
                                />
                              </div>
                            </Col>
                            <Col xs={4} style={{ marginTop: "10px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Post
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="smtpPost"
                                  value={smtpPost}
                                  onChange={({ target }) => {
                                    setSmtpPost(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  prefix={<DatabaseOutlined />}
                                />
                              </div>
                            </Col>

                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  ใช้งาน Username Password
                                </Typography.Title>
                                <Radio.Group
                                  value={usernameCheck}
                                  defaultValue={"user-no"}
                                  onChange={handleRadioChange}
                                  style={{ fontSize: "24px" }}
                                >
                                  <Radio
                                    value={"user-yes"}
                                    style={{ fontSize: "17px" }}
                                  >
                                    เปิดใช้งาน
                                  </Radio>
                                  <Radio
                                    value={"user-no"}
                                    style={{ fontSize: "17px" }}
                                  >
                                    ปิดใช้งาน
                                  </Radio>
                                </Radio.Group>
                              </div>
                            </Col>
                            <Col xs={8} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Username
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="username"
                                  value={username}
                                  onChange={({ target }) => {
                                    setUsername(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  disabled={isEnabled}
                                  prefix={<UserOutlined />}
                                />
                              </div>
                            </Col>
                            <Col xs={4} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  SMTP Password
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="password"
                                  value={
                                    showPassword ? password : displayPassword
                                  }
                                  onChange={handlePasswordChange}
                                  style={{ height: "40px" }}
                                  disabled={isEnabled}
                                  prefix={<LockOutlined />}
                                  suffix={
                                    <span
                                      onClick={togglePasswordVisibility}
                                      style={{
                                        cursor: "pointer",
                                        color: "blue",
                                      }}
                                    >
                                      {showPassword ? "ซ่อน" : "แก้ไข"}
                                    </span>
                                  }
                                />
                              </div>
                            </Col>

                            {/* <Col xs={12} style={{ marginTop: '30px' }}>
                                        <div>
                                            <Typography.Title level={5}>Transport Layer Security SSL (TLS)</Typography.Title>
                                            <Radio.Group defaultValue={"transport-yes"} style={{ fontSize: '24px' }}>
                                                <Radio value={"transport-yes"} style={{ fontSize: '17px' }}>เปิดใช้งาน</Radio>
                                                <Radio value={"transport-no"} style={{ fontSize: '17px' }}>ปิดใช้งาน</Radio>
                                            </Radio.Group>
                                        </div>
                                    </Col> */}
                          </Row>
                        )}
                      </Col>

                      <Col xs={12} style={{ marginTop: "30px" }}>
                        {(valueCheck === "use-inet" ||
                          valueCheck === "no-inet") && (
                          <Row>
                            <Col xs={12}>
                              <div>
                                <Typography.Title level={5}>
                                  ชื่อผู้ส่ง (Sender Display Name)
                                </Typography.Title>
                                <Input
                                  placeholder="Consent Management Platform"
                                  id="senderName"
                                  value={senderName}
                                  onChange={({ target }) => {
                                    setSenderName(target.value);
                                  }}
                                  style={{
                                    height: "40px",
                                    borderColor: errors.senderName
                                      ? "red"
                                      : undefined,
                                  }}
                                  prefix={<UserOutlined />}
                                />
                                {errors.senderName && (
                                  <div style={{ color: "red" }}>
                                    {errors.senderName}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  อีเมลแอดเดรสผู้ส่ง (Sender Email Address)
                                </Typography.Title>
                                <Input
                                  placeholder="no-reply-cmp@cmp.inet.co.th"
                                  id="senderEmail"
                                  value={senderEmail}
                                  onChange={({ target }) => {
                                    setSenderEmail(target.value);
                                  }}
                                  style={{
                                    height: "40px",
                                    borderColor: errors.senderEmail
                                      ? "red"
                                      : undefined,
                                  }}
                                  prefix={<MailOutlined />}
                                />
                                {errors.senderEmail && (
                                  <div style={{ color: "red" }}>
                                    {errors.senderEmail}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div>
                                <Typography.Title level={5}>
                                  ส่งสำเนาถึง (BBC Email Address)
                                </Typography.Title>
                                <Input
                                  placeholder=""
                                  id="senderBCC"
                                  value={senderBCC}
                                  onChange={({ target }) => {
                                    setSenderBCC(target.value);
                                  }}
                                  style={{ height: "40px" }}
                                  prefix={<SwitcherOutlined />}
                                />{" "}
                                <br />
                                <br />
                                {/* <span style={{ fontSize: '16px', fontWeight: 'bold', color: 'red' }}>หมายเหตุ: สามารถใช้เครื่องหมาย , (จุลภาค) หากต้องการส่งมากกว่า 1 อีเมล</span> */}
                              </div>
                            </Col>
                            <Col xs={12} style={{ marginTop: "30px" }}>
                              <div className="d-flex justify-content-center">
                                <Button
                                  style={{
                                    width: "250px",
                                    fontSize: "16px",
                                    marginRight: "10px",
                                  }}
                                  sx={
                                    !!style.primary_color && {
                                      backgroundColor: `${style.secondary_color} !important`,
                                      color: fontColor(style.secondary_color),
                                    }
                                  }
                                  onClick={() => {
                                    updateSMTP();
                                  }}
                                >
                                  บันทึก
                                </Button>
                                <Button
                                  variant="outlined"
                                  color="error"
                                  style={{ width: "250px", fontSize: "16px" }}
                                  onClick={() => {
                                    setStep("home");
                                  }}
                                >
                                  ยกเลิก
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Card>
              </>
            ),
          }[step]
        }
      </FadeIn>
    );

}

export default EmailSMTP